import { render, staticRenderFns } from "./rect-form.vue?vue&type=template&id=1ed49788&"
import script from "./rect-form.vue?vue&type=script&lang=js&"
export * from "./rect-form.vue?vue&type=script&lang=js&"
import style0 from "./rect-form.vue?vue&type=style&index=0&id=1ed49788&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports